// Modalità compenso del collaboratore (03/11/2026: aggiunta FISSO_ORE = fisso mensile + tutte le ore a tariffa)
export const MODALITA_COMPENSO = [['ORARIO', 'A ore'], ['FISSO', 'Fisso mensile'], ['FISSO_ORE', 'Fisso + ore']];

export const nomeModalita = (m) => (MODALITA_COMPENSO.find(([v]) => v === m) || MODALITA_COMPENSO[0])[1];

const euro = (n) => `€${(n || 0).toFixed(2)}`;

// Riga breve per elenchi e intestazioni: "€500.00/mese (fisso)", "€20.00/h", "€500.00/mese + €20.00/h"
export const descriviCompenso = (d) => {
  if (!d) return '';
  if (d.modalita_compenso === 'FISSO') return `${euro(d.compenso_fisso)}/mese (fisso)`;
  if (d.modalita_compenso === 'FISSO_ORE') return `${euro(d.compenso_fisso)}/mese + ${euro(d.tariffa_oraria)}/h`;
  return `${euro(d.tariffa_oraria)}/h`;
};

// la mensilità fissa va inserita ogni mese in Paghe (FISSO e FISSO_ORE)
export const haFisso = (m) => m === 'FISSO' || m === 'FISSO_ORE';
